import { useLocalizedDate } from '@urc-ui/hooks/i18n/index';
import { DEFAULT_DATE_FORMAT } from '@urc-ui/utils/date-utils';
import { PRESET_PERIOD } from '@urc-ui/utils/types';
import { TranslateMapConfig, useTranslateMap } from '@urc-ui/hooks/translate-map';

const useFormattedReportPeriod = (
  translateMap: TranslateMapConfig,
  reportPeriod: string,
  startAt?: number | string,
  endAt?: number | string
) => {
  const upperCaseReportPeriod = reportPeriod.toUpperCase();
  const startDate = startAt ? new Date(startAt) : null;
  const endDate = endAt ? new Date(endAt) : null;

  const [localizedStartDate, localizedEndDate] = useLocalizedDate([
    {
      value: startDate,
      format: {
        ...DEFAULT_DATE_FORMAT,
        timeZone: 'UTC'
      }
    },
    {
      value: endDate,
      format: {
        ...DEFAULT_DATE_FORMAT,
        timeZone: 'UTC'
      }
    }
  ]);
  const translateReportPreset = useTranslateMap(translateMap);

  if (PRESET_PERIOD.CUSTOM && startAt && endAt) {
    return `${localizedStartDate} - ${localizedEndDate}`;
  }

  return translateReportPreset[upperCaseReportPeriod] ? translateReportPreset[upperCaseReportPeriod] : upperCaseReportPeriod;
};

export { useFormattedReportPeriod };
